﻿// Fonts
require("@cirrus/legacy/vendor-bower/components-font-awesome/css/font-awesome.css")
require("@cirrus/legacy/vendor-static/font-opensans/css/style.css")
